import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { setInitialStoreState } from '../../../../common/utils';
import { ShipmentWaybillItemFacade } from './shipment-waybill-item.facade';
import { Injectable } from '@angular/core';
import { WaybillIdView } from '../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillItemGuard {
  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      queryParams: {
        carrierId = null,
        carrierTO = null,
        hawb = null,
        hbl = null,
        mbl = null,
        waybillIdType = null,
        internalWaybillId = null,
      },
    } = route;
    const identifier: WaybillIdView = { carrierId, carrierTO, hawb, hbl, mbl, waybillIdType, internalWaybillId };

    this.shipmentWaybillItemFacade.setShipmentWaybillIdentifier(identifier);
    this.shipmentWaybillItemFacade.loadShipmentWaybillDemurrageAndDetentionTabAvailability(internalWaybillId);
    this.shipmentWaybillItemFacade.loadShipmentWaybillNotificationListCount(identifier);
    this.shipmentWaybillItemFacade.loadShipmentWaybillCustomsDocumentsCount(identifier);

    return of(true);
  }

  constructor(private shipmentWaybillItemFacade: ShipmentWaybillItemFacade) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentWaybillItemFacade);
  }
}
